import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignUp } from "@clerk/react";
import { useAuth } from "@/contexts/AuthContext";
import ClerkAuthShell from "@/components/ClerkAuthShell";

/**
 * Clerk <SignUp /> is waitlist-mode aware: with Waitlist enabled in the
 * Clerk Dashboard this is the native waitlist form. Switching the instance
 * to Public turns it into standard sign-up with no code change.
 */
export default function SignUpPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  return (
    <ClerkAuthShell testId="signup-page">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/login"
        forceRedirectUrl="/dashboard"
        fallbackRedirectUrl="/dashboard"
      />
    </ClerkAuthShell>
  );
}
